<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';
    import CoachingFormQuestion from './CoachingFormQuestion.vue';
    import { ProtocolFormStateQuestion } from './coachingForm.types';
    import { useSectionColor } from '@/js/composables/useSectionColor';

    defineProps<{
        protocolId?: string;
        questions: ProtocolFormStateQuestion[];
        preview?: boolean;
        sectionIndex: number;
    }>();

    const { getCardHeaderBgColor } = useSectionColor();
</script>
<template>
    <div class="heading-sm">
        <div
            class="question-row-grid h-12 items-center border-b border-gray-light"
            :class="getCardHeaderBgColor(sectionIndex)"
        >
            <p class="text-body-bold text-left px-5">
                {{ __('question-title') }}
            </p>
            <p class="text-body-bold text-left px-5">
                {{ __('coaching-form-answer-options') }}
            </p>
            <p class="text-body-bold text-left px-5">
                {{ __('coaching-form-points') }}
            </p>
        </div>
        <div class="bg-white divide-y divide-gray-light">
            <CoachingFormQuestion
                v-for="question in questions"
                :key="question.id"
                :protocol-id="protocolId"
                :question="question"
                :preview="preview"
            />
        </div>
    </div>
</template>
